import { AUTOPAY } from "@payment-client/constants/Autopay";

export const getAutopayFeedbackUrl = (): string => {
    return window?.__AUTOPAY_FEEDBACK_URL__ || AUTOPAY.FEEDBACK_URL;
};
